

import { useTheme } from '@mui/material';
import { FC, Suspense, lazy } from 'react';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

const SpeciesContentStyles = lazy(() => import('./SpeciesContentStyles'));


interface ISpeciesContentRendererProps {
    pageContent: string;
}

const SpeciesContentRenderer: FC<ISpeciesContentRendererProps> = ({
    pageContent
}) => {
    const theme = useTheme();

    const cleanHtml = DOMPurify.sanitize(pageContent);
    
    return (
        <Suspense
            fallback={<div></div>}
        >
            <SpeciesContentStyles
                background='/images/bg_plain.png'
                contrastColor='#673628'
                headerHeight={75}
                primaryColor={theme.palette.primary.main}
                secondaryColor={theme.palette.secondary.main}
            >
                { parse(cleanHtml) }
            </SpeciesContentStyles>
        </Suspense>
    )
}

export default SpeciesContentRenderer